export const getAssetDisplayName = (asset) => asset?.displayName || asset?.name || '';

export const normalizeAssetKey = (value) =>
  String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

export const findAssetByCodeOrName = (assets = [], target) => {
  const targetCode = target?.code || target?.assetCode || target?.focusAreaCode;
  const targetName = target?.answer || target?.displayName || target?.name || target;
  const normalizedTargetName = normalizeAssetKey(targetName);

  if (targetCode) {
    const assetByCode = assets.find((asset) => asset?.code === targetCode);
    if (assetByCode) return assetByCode;
  }

  return assets.find((asset) => {
    const candidates = [asset?.displayName, asset?.name, asset?.code];
    return candidates.some((candidate) => normalizeAssetKey(candidate) === normalizedTargetName);
  });
};
